export default __webpack_public_path__ + "static/media/landing-commas-icon.3b8f9545.svg";